import Refurbishment41_5Header from "./Header";
import "./index.css";
import { useState } from "react";
import InputsFromRefurbishment41_5a from "../ProdUseStage41/InputsFromRefurbishment41_5a";
import SurplusResourcesRefurbishment41_5b from "../ProdUseStage41/SurplusResourcesRefurbishment41_5b";
import Flow41_6 from "../ProdUseStage41/Flow41_6";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const ProdRefurbishment41_5Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });
  const [totalProdItem, setTotalProdItem] = useState([]);

  return (
    <div className="prod-refurbishment-41-5-container" id="prod-refurbishment-41-5-id">
      <Refurbishment41_5Header
        productId={productId}
        show={show}
        totalProdItem={totalProdItem}
      />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <InputsFromRefurbishment41_5a productId={productId} />
          <SurplusResourcesRefurbishment41_5b productId={productId} />
          <Flow41_6 productId={productId} />
        </div>
      )}
    </div>
  );
};

export default ProdRefurbishment41_5Components;

